import { Signal, Req } from 'badmfck-signal'

class GD {
  /**
   * GUI
   * */
  static GUI_MESSAGES_RENDERED: Signal<void> = new Signal()
  static GUI_CLOSE_CHAT: Signal<void> = new Signal()
  static GUI_OPEN_CHAT: Signal<void> = new Signal()
  static GUI_CHAT_CLOSED: Signal<void> = new Signal()
  static GUI_CHAT_OPENED: Signal<void> = new Signal()
  static GUI_REPOSITION_CHAT: Signal<void> = new Signal()

  /**
   * Common
   * */
  static SERVICE_READY: Signal<string> = new Signal()
  static REQ_HTTP: Req<APIRequest, APIResponse> = new Req()
  static ALERT_ERROR: Signal<string> = new Signal()

  /**
   * Auth
   * */
  static AUTH_COMPLETE: Signal<IAuth> = new Signal()
  static REQUEST_AUTHENTICATE: Signal<void> = new Signal()
  static LOGOUT: Signal<void> = new Signal()
  static GET_PROFILE: Req<void, IProfile | undefined> = new Req()

  /**
   * Chat
   * */
  static SET_CHAT: Signal<ChatVO> = new Signal()
  static CLOSE_CHAT: Signal<void> = new Signal()
  static GET_CHAT: Req<void, ChatVO> = new Req()
  static CHAT_MESSAGE_SEND_REQUEST: Signal<string> = new Signal()
  static CHAT_BOT_COMMAND_SEND_REQUEST: Signal<{ title: string, action: string, actionData: string | null, botUID: string }> = new Signal()
  static SEND_INPUT_ACTIVITY: Signal <{isTyping: boolean}> = new Signal()

  /**
   * Message
   * */
  static SET_MESSAGES: Signal<IMessage[]> = new Signal()
  static FETCH_MORE_MESSAGES: Req<void, void> = new Req()

  /**
   * Images
   * */
  static UPLOAD_IMAGE: Req<{ tempUID:string, file: File }, boolean> = new Req()
  static FETCH_IMAGE: Req<{ thumb?: boolean, imageUID: string }, string | null> = new Req()
  static DOWNLOAD_IMAGE: Signal<ImageRequest> = new Signal()

  /**
   * FileUpload
   * */
  static REQ_FILE_UPLOAD: Req<{tempUID: string, file: File }, boolean> = new Req()
  static FILE_DOWNLOAD_REQUEST: Signal<{ uid: string, name: string }> = new Signal()
  static FILE_PROGRESS_UPDATE: Signal<{ tempUID: string, progress: number }> = new Signal()
  static FILE_PROGRESS_DELAY: Signal<{ delay: boolean }> = new Signal()
  static SEND_FILES: Signal<File[]> = new Signal()
  static FILE_UPLOADING_LIST_UPDATED: Signal<UploadingFileVO[]> = new Signal()

  /**
   * WS
   * */
  static WS_MSG: Signal<{ method: string, data: IObjectData | null }> = new Signal()
  static WS_SEND: Signal<{ method: string, data: IObjectData | null }> = new Signal()
  static WS_AUTHORIZED: Signal<string | undefined | null> = new Signal() // user type
  static WS_CLOSED: Signal<void> = new Signal()
  static WS_MSG_SENT_VIA_HTTP: Signal<{ num: number, id: number, chatUID: string, text: string }> = new Signal()
  static INVOKE_DELAYED_EVENTS: Signal<DelayedPacket[]> = new Signal()
  static REQ_WS_STATUS: Req<void, number> = new Req()

  /**
  * Logger
  * */
  static LOG: Signal<string | object> = new Signal()
  static LOGE: Signal<string | object> = new Signal()
}
export default GD
